import { IRow } from "../types";

export const form3HeaderCells = ["№п/п", "КВР", "Наименование расходов (с расшифровкой)", "Сумма (руб.)"];

export const form3Rows: IRow[] = [
    {
        col1: "1",
        col2: "111",
        col3: "Оплата труда",
        col4: { name: "info.f3.n1", numeric: true },
    },
    {
        col1: "2",
        col2: "119",
        col3: "Страховые взносы",
        col4: { name: "info.f3.n2", numeric: true },
    },
    {
        col1: "3",
        col2: "244",
        col3: "Прочая закупка товаров, работ, услуг ",
        col4: { name: "info.f3.n3", numeric: true },
    },
];
